import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { useTranslation } from "@/hooks/useTranslation";

export default function ReferredByField({
  form,
  disabled,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
  disabled?: boolean;
}) {
  const t = useTranslation();

  return (
    <>
      <FormField
        control={form.control}
        name="referredBy"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel className="text-gray-400">
              {t.USER_FORM.LABELS.REFERRED_BY}
            </FormLabel>
            <div>
              <FormControl>
                <Input
                  {...field}
                  value={field.value || ""}
                  placeholder={t.USER_FORM.PLACEHOLDERS.REFERRED_BY_INPUT}
                  className="text-base"
                  spellCheck="false"
                  disabled={disabled}
                />
              </FormControl>
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />
    </>
  );
}
